<template>
    <div id="feedback">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <div class="full">
                        <div class="alert_title flex jb ac">
                            <p>效果满意度</p>
                            <img src="./img/close.png"
                                 @click="close"
                                 class="close" />
                        </div>
                        <div class="list flex ac jb">
                            <div class="item flex fc ac"
                                 :class="active==index?'active':''"
                                 @click="choose_item(index)"
                                 v-for="item,index in list"
                                 :key="index">
                                <img :src="require(`./img/f${index+1}.png`)" />
                                <p>{{item}}</p>
                            </div>
                        </div>
                        <div class="content">
                            <el-input type="textarea"
                                      maxlength="200"
                                      tabindex="0"
                                      resize="none"
                                      class="textarea"
                                      autocomplete="off"
                                      placeholder="请输入您的建议（200字内）"
                                      v-model.trim="content"></el-input>
                        </div>
                        <div class="btn">
                            <span @click="submit">提交</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    props: ['draw_item'],
    data () {
        return {
            list: ['不满意', '一般', '满意'],
            active: 2,
            content: ''
        }
    },
    created () {

    },
    computed: {

    },
    methods: {
        choose_item (index) {
            this.active = index
        },
        //关闭弹窗
        close () {
            this.content = ''
            this.$emit('close', false)
        },
        //提交
        submit () {
            if (this.content == '') {
                this.$message({
                    message: '请输入您的建议',
                    type: 'warning'
                });
                return
            }
            //进行网络请求
            let data = {}
            this.$http.patch(`/front/aimj/user/draw/${this.draw_item.draw_id}/`, {'action':'feedback', 'data':{'content':this.content}}).then((res) => {
                if (res.status == 200) {
                    this.$message({
                        message: '反馈成功',
                        type: 'success'
                    });
                    this.close()
                } else {
                    this.$confirm(message, '提示', {
                        type: 'warning'
                    }).then(() => {
                    })
                }
            }).finally((res) => {

            })
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#feedback {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        .con {
            width: 300px;
            padding: 20px 15px;
            background-color: #1e1f22;
            border-radius: 6px;
            .full {
                position: relative;
                display: flex;
                flex-direction: column;
                height: 100%;
                .alert_title {
                    p {
                        font-size: 14px;
                        color: #fff;
                        font-weight: bold;
                    }
                    .close {
                        width: 16px;
                        height: 16px;
                        cursor: pointer;
                    }
                }
                .list {
                    margin: 20px 0;
                    padding: 0 20px;
                    .item {
                        width: 60px;
                        padding: 10px 0;
                        cursor: pointer;
                        img {
                            margin-bottom: 5px;
                        }
                        p {
                            font-size: 14px;
                            color: #fff;
                        }
                        &.active {
                            background: #343538;
                            border-radius: 4px;
                        }
                    }
                }
                .content {
                    .textarea {
                        color: #fff;

                        /deep/textarea {
                            background: transparent;
                            height: 100px;
                        }
                        /deep/.el-textarea__inner:focus {
                            border-color: #fff;
                        }
                    }
                }
                .btn {
                    span {
                        display: block;
                        margin: 20px auto 0;
                        border-radius: 40px;
                        cursor: pointer;
                        background-color: #5865f2;
                        color: #fff;
                        border-radius: 10rpx;
                        width: 150px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        font-size: 16px;
                        &:hover {
                            opacity: 0.8;
                        }
                    }
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>